import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const postOutboundResolved = createApi(`OutboundResolvedSlice`,"POST");

const OutboundResolvedSlice = createSlice({
  name: 'OutboundResolvedSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postOutboundResolved.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postOutboundResolved.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(postOutboundResolved.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default OutboundResolvedSlice.reducer;